import { useCallback, useEffect, useState } from "react";
import { getCatalogoModems } from "../services/reqSolicitudes";

export function useCatalogoModems({ cod, sucursal, q, page, limit, enabled = true }) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetch = useCallback(async () => {
    if (!enabled) {
      setItems([]);
      setTotal(0);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const params = { buscar: q, page, limit };
      if (sucursal) params.ciudad = "";
      const resp = await getCatalogoModems(cod, params);
      const arr = resp?.data?.items || [];
      const tot = resp?.data?.total || 0;
      setItems(arr);
      setTotal(tot);
    } finally {
      setLoading(false);
    }
  }, [cod, sucursal, q, page, limit, enabled]);

  useEffect(() => { fetch(); }, [fetch]);

  return { items, total, loading, refetch: fetch };
}
